<template>
    <b-row>
        <b-col cols="7">
            <div class="card p-2">
                <b-input-group  class="green_search mb-3">
                    <b-input-group-prepend>
                        <span class="input-group-text">
                            <i  class="fas fa-search"></i>
                        </span>
                        
                    </b-input-group-prepend>
                    <b-form-input size="lg"></b-form-input>
                </b-input-group>
                <webix-ui :config="ui" v-model="stats"></webix-ui>
            </div>
        </b-col>
        <b-col cols="5">
            <div class="card mb-4">
                <div style="width:fit-content; color: #ffffff;  border-radius: 0.2rem;" class="text-light card-title card ccb_green p-2">
                    Client User Details
                </div>
                <div v-if="selected_sop != null">
                    <p>
                        <span style="font-weight: bold;">Current SOP No: </span>
                        <span>{{selected_sop.sop_code}}</span>
                    </p>
                    <p>
                        <span style="font-weight: bold;">Number Of Revisions: </span>
                        <span>N/A</span>
                    </p>
                    <p>
                        <span style="font-weight: bold;">Date Of Distribution: </span>
                        <span>N/A</span>
                    </p>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <apexchart
                    v-if="selected_sop != null && selected_sop == 'fruit'"
                      type="donut"
                      :series="chart_config.series"
                      :options="chart_config.chartOptions"
                    ></apexchart>
                    <b-alert v-if="selected_sop == null" show>
                        <h2>Select a SOP</h2>
                    </b-alert>
                </div>
                
            </div>
        </b-col>
    </b-row>
</template>

<script>
import ApexCharts from 'apexcharts'
import { sopClientAdminState, sopClientAdminMethods } from '@/state/helpers'
import _ from 'lodash'
export default {
    data:() => ({
        selected_sop: null,
        ui:{
            id: 'statsTable',
            view:'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            editable: true,
            columns:[
                { id:"id", header:"", hidden: true, fillspace: 0},
                { id:"company_name", header:"Company Name", fillspace: true},
                { id:"contact_person", header:"Contact Person", fillspace:0.8},
                { id:"sop_status", header:"Client SOP Status", fillspace:0.6},
                { id:"sop_revision_no", header:"Client SOP Revision", fillspace:0.6},
                { id: "actions", header: "Action", fillspace: 0.5,
                    editor: 'select',
                    options:[
                        { id: 'action', value: 'Action'},
                        { id: 'flag', value: 'Flag'},
                        { id: 'reminder', value: 'Send Reminder'},
                        { id: 'update', value: 'Update SOP'},
                    ]
                }
            ],
            on: {
                onItemClick(id){
                    let el = this.$scope.$parent;
                    var item = this.getItem(id)
                    el.selected_sop = item;

                    let params = {
                        type_id: el.context_menu_id,
                        client_id: item.id,
                    }
                    el.loadClientSop(params)
                },
                onEditorChange(id, value){
                    this.editStop();
                    let el = this.$scope.$parent;
                    switch(value){
                        case 'update':{
                            el.editDocument(id);
                            break;
                        }
                        default:{
                            console.log('Not added yet');
                        }
                    }
                    let item = this.getItem(id);
                    item.actions = 'action';
                    this.updateItem(id, item);
                    this.refresh();
                },
            },
            onClick:{},
        },
        chart: null,
        chart_config:{
            series: [30, 70],
            chartOptions: {
                chart:{
                    type: 'donut'
                },
                labels: ["Adopted", "Unadopted",],
                colors: ["#34c38f", "#556ee6"],
                legend: {
                    show: true, position: 'bottom', horizontalAlign: 'center', verticalAlign: 'middle', floating: false, fontSize: '14px', offsetX: 0
                },
                responsive: [
                    {
                        breakpoint: 600,
                        options: {
                            chart: {
                                height: 240
                            },
                            legend: {
                                show: false
                            },
                        }
                    }
                ]
            }
        }
    }),
    computed:{
        ...sopClientAdminState,
        stats(){
            if(this.sop_stats == null){
                return [];
            }
            else{
                let data = _.cloneDeep(this.sop_stats);
                data.forEach( item => {
                    item['actions'] = 'action';
                });
                return data;
            }
        }
    },
    watch:{
        stats(){
            if(this.stats.length > 0){
                let table = window.webix.$$('statsTable');
                if(table != undefined){
                    table.select(this.stats[0].id);
                }
            }
        }
    },
    methods:{
        ...sopClientAdminMethods,
        //eslint-disable-next-line
        editDocument(id){
            this.$emit('editClientSop')
        }
    },
    mounted(){
        if(this.stats == 'remove'){
            this.chart = new ApexCharts(document.querySelector("#chart"), this.chart_config);
            this.chart.render();
        }
    },
}
</script>

<style>
/* ccs for webix actions dropdown */
select>option{
    font-size: 1.1rem;
}


.input-group-text {
  height: 100%;
  border-right: none;
  background-color: #ffffff;
  color: var(--bs-success)
}
.green_search{
    border: 2px solid var(--bs-success);
    border-radius: 0.4rem;
}
.green_search > input{
    border: 0px;
}
.green_search > div > span{
    border: 0px;
}
</style>